import { useContext, useEffect, useMemo } from "react"
import { MenuItem, Select } from "@mui/material"
import { useSortedModels } from "resources/models"
import { usePortfolios } from "resources/portfolios"
import { combineStatuses, OK } from "helpers/data-statuses"
import { getMostUsedOrDefaultModelId } from "helpers/models"
import { IDashboardContext } from "connected-components/dashboard/context/types"

export default function ModelSelector({ context, disabled = false }: ModelSelectorProps) {
  const { modelId, setModelId } = useContext(context)
  const [portfolios, portfoliosStatus] = usePortfolios()
  const [models, modelsStatus] = useSortedModels()

  const status = useMemo(
    () => combineStatuses([modelsStatus, portfoliosStatus]),
    [modelsStatus, portfoliosStatus],
  )

  useEffect(
    () => {
      if (modelsStatus === OK && portfoliosStatus === OK && !modelId) {
        const defaultModelId = getMostUsedOrDefaultModelId(portfolios, models)
        if (defaultModelId) {
          setModelId(defaultModelId)
        }
      }
    },
    [modelId, setModelId, portfolios, models, modelsStatus, portfoliosStatus],
  )

  if (status !== OK) {
    return <div>Loading</div>
  }

  return <Select
    data-test-id="model-selector"
    variant="standard"
    value={modelId || ""}
    onChange={(e) => setModelId(e.target.value)}
    MenuProps={{
      disablePortal: true,
    }}
    disabled={disabled}
  >
    {/*
      [TODO:TS] Strong typing of models at not nullable doesn't survive combineStatuses.
      We are still considering different options to fix this with a better combine function,
      but we want to see more examples of components before.
     */}
    {models?.map(({ id, name }) => <MenuItem data-test-class="model-selector-item" key={id} value={id}>{name}</MenuItem>)}
  </Select>
}

interface ModelSelectorProps {
  context: IDashboardContext
  disabled?: boolean
}
